import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { JobMonitor } from '../../components/JobMonitor'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/workers')({
  component: WorkersPage,
})

function WorkersPage() {
  const { data: session } = useSession()
  const logout = useLogout()
  const user = session?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <JobMonitor />
    </AppShell>
  )
}
